import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFloorLoading } from '../../../../store/slices/projectItemSlice';
import { setAllItems } from '../../../../store/slices/imageOverlaySlice';
import { setAllShapes } from '../../../../store/slices/drawingSlice';
import { loadImageItems } from './Drawing/drawingService';
import { useProjectHeader } from '../../../../pages/buildProject/Helpers/pageDiv/ProjectHeaderContext';

export default function FloorLoadingGate() {
  const dispatch     = useDispatch();
  const currentFloor = useSelector((s) => s.api.currentFloor);
  const floorId      = currentFloor?.enc_id ?? null;
  const versionRef   = useRef(0);
  const firstRun     = useRef(true);

  const { reset } = useProjectHeader();

  useEffect(() => { 
    if (!floorId) {
      dispatch(setFloorLoading(false));
      return;
    }
 
    if (firstRun.current) {
      firstRun.current = false;
    } else {
      dispatch(setAllItems([]));
      dispatch(setAllShapes([]));
    }

    versionRef.current += 1;
    const version = versionRef.current;

    loadImageItems(floorId)
      .finally(() => {
        if (version === versionRef.current) {
          dispatch(setFloorLoading(false));
        }
      });
  }, [floorId, dispatch, reset]);

  return null;
}
